import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { addMethod, mixed } from "yup";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import Login from "./pages/Login";

// pages
const Categories = lazy(() => import("./pages/Categories"));
const Admins = lazy(() => import("./pages/Admins"));
const Employees = lazy(() => import("./pages/Employees"));
const Settings = lazy(() => import("./pages/Settings"));
const Page404 = lazy(() => import("./pages/Page404"));

// custom yup method to convert empty strings to undefined
addMethod(mixed, "optional", function () {
  return this.transform((value) => {
    if (!value) return undefined;
    return value;
  });
});

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/categories" />} />
        <Route path="categories" element={<Categories />} />
        <Route path="admins" element={<Admins />} />
        <Route path="employees" element={<Employees />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  );
}

export default App;
